import React from 'react';
import { FaBook, FaHeart, FaUsers } from 'react-icons/fa';

const WhatWeDo: React.FC = () => {
  const services = [
    {
      title: 'Education for All',
      description: 'Supporting children with quality education and resources',
      icon: <FaBook className="w-8 h-8" />,
      color: 'from-blue-600 to-blue-800',
      iconBg: 'bg-blue-100/30'
    },
    {
      title: 'Healthcare Support',
      description: 'Improving access to basic healthcare services',
      icon: <FaHeart className="w-8 h-8" />,
      color: 'from-green-600 to-green-800',
      iconBg: 'bg-green-100/30'
    },
    {
      title: 'Women Empowerment',
      description: 'Skill development and mentorship programs',
      icon: <FaUsers className="w-8 h-8" />,
      color: 'from-purple-600 to-purple-800',
      iconBg: 'bg-purple-100/30'
    }
  ];

  return (
    <section id="what-we-do" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-4xl md:text-4xl font-bold text-gray-900 mb-6">What We Do</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-primary to-secondary mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <div className="p-8">
                <div className="mb-6 flex justify-center">
                  <div className={`w-20 h-20 rounded-2xl ${service.iconBg} flex items-center justify-center`}>
                    <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${service.color} text-white flex items-center justify-center shadow-lg`}>
                      {service.icon}
                    </div>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">{service.title}</h3>
                <p className="text-gray-600 text-center">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
